import { SActionBtn, SLowcodeList, STableActions } from 'shj-components'
import { useRef, useState } from 'react'
import {
  delDdealkingVenueQrCode,
  fetchDealkingVenueQrCode,
  getDictByParentKey,
} from '@/services/talkOrder'
import { get } from 'lodash-es'
import { message, Modal, QRCode, Switch } from 'antd'
import AddOrEditDom from './addOrEdit'
import config from './config'
import { fetchAllList, GetUserCompanys } from '@/services'
import { isValidArray } from '@/utils'

const SpaceVenueQRCodeList = () => {
  const listRef = useRef<any>()
  const [isVisible, setIsVisible] = useState(false)
  const [currentRecord, setCurrentRecord] = useState<any>()
  const [categoryList, setCategoryList] = useState<any>([])
  const [companyListData, setCompanyListData] = useState<any>([])
  const [currentCode, setCurrentCode] = useState<any>({})
  const [isCodeVisible, setIsCodeVisible] = useState(false)

  const fetchList = ({ current, pageSize, query }: any) => {
    return new Promise((resolve, reject) => {
      try {
        fetchDealkingVenueQrCode({ current, pageSize, data: query }).then((res: any) => {
          const records = get(res, 'list')
          const total = get(res, 'count')
          resolve({ records, total })
        })
      } catch (e) {
        reject({ success: false })
      }
    })
  }

  const getStatusOptions = () => {
    return new Promise(async resolve => {
      const companyList = await getCompanyListData()
      const categoryList = await getCategoryListData()
      resolve({
        companyList,
        categoryList,
      })
    })
  }

  const getCategoryListData = () => {
    return getDictByParentKey({ parentKey: 'exhibitionHallZone' }).then((res: any) => {
      setCategoryList(res)
      return res
    })
  }

  const getCompanyListData = () => {
    return GetUserCompanys().then((data: any[]) => {
      setCompanyListData(data)
      return data
    })
  }

  const downLoadFn = (record: any) => {
    console.log(record, 11111)

    // const { id } = record
    const node = document.getElementById(`${record.id}Con`)?.querySelector<HTMLCanvasElement>('svg')

    // return
    if (node) {
      let serializer = new XMLSerializer()
      let source = '<?xml version="1.0" standalone="no"?>\r\n' + serializer.serializeToString(node)
      let image = new Image()
      image.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(source)
      let canvas = document.createElement('canvas')
      const width = 320,
        height = 320
      canvas.width = width
      canvas.height = height
      let context = canvas.getContext('2d')!
      context.fillStyle = '#fff'
      context.fillRect(0, 0, width, height)
      image.onload = function () {
        context.drawImage(image, 0, 0, width, height)
        let a = document.createElement('a')
        a.download = `${record?.companyName}_${record?.areaTypeDesc}_${record?.alias}.png`
        a.href = canvas.toDataURL(`image/png`)
        a.click()
      }
    }
  }

  const getSelected = () => {
    const [selectedRowKeys, selectedRows] = listRef.current.getSelectedRows()
    return selectedRows
  }

  const multiDownload = () => {
    const selectedList = getSelected()
    if (!isValidArray(selectedList)) {
      message.warning('请勾选数据')
      return
    }
    console.log(listRef.current.getSelectedRows())

    selectedList?.forEach((item: any) => {
      downLoadFn(item)
    })
  }

  const onDel = (record: any) => {
    delDdealkingVenueQrCode(record?.id).then((res: any) => {
      message.success('删除成功')
      listRef.current.reload()
    })
  }

  const onAdd = () => {
    setIsVisible(true)
  }

  const onEdit = (record: object) => {
    setIsVisible(true)
    setCurrentRecord(record)
  }

  const extension = {
    request: { fetchList, getStatusOptions },
    events: { multiDownload, onAdd },
    // auth,
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      actionTool(text: any, record: any) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
            <SActionBtn onClick={() => downLoadFn(record)}>下载二维码</SActionBtn>
            <SActionBtn confirm danger title="确定删除?" onClick={() => onDel(record)}>
              删除
            </SActionBtn>
          </STableActions>
        )
      },
      useCompanyListFn(text: any, record: any) {
        const arr: any = []
        text?.forEach((item: any) => {
          arr?.push(item?.busName)
        })
        return arr.toString()
      },
      qrCodeFn(text: any, record: any) {
        const value = {
          busId: record?.id,
          busType: 'hallSignIn',
          busName: record?.name,
          companyCode: record?.companyCode,
          companyName: record?.companyName,
          alias: record?.alias,
          areaType: record?.areaType,
          areaTypeDesc: record?.areaTypeDesc,
        }
        return record?.id ? (
          <div
            id={`${record?.id}Con`}
            onClick={() => {
              setIsCodeVisible(true)
              setCurrentCode(value)
            }}
          >
            <QRCode
              value={JSON.stringify(value)}
              type="svg"
              size={80}
              bordered={false}
              style={{ padding: 0, borderRadius: 0 }}
            />
          </div>
        ) : null
      },
      currentActivityFn(text: any) {
        return <Switch disabled={true} checked={text} />
      },
    },
  }

  return (
    <div>
      <SLowcodeList config={{ ...config }} ref={listRef} {...extension} />
      {isVisible ? (
        <AddOrEditDom
          record={currentRecord}
          onClose={() => {
            setCurrentRecord(undefined)
            setIsVisible(false)
          }}
          reload={() => listRef.current.reload()}
          categoryList={categoryList}
          companyListData={companyListData}
        />
      ) : null}
      {isCodeVisible ? (
        <Modal
          open={true}
          footer={null}
          style={{ display: 'flex', justifyContent: 'center' }}
          onCancel={() => setIsCodeVisible(false)}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '40px 0 20px',
            }}
          >
            <QRCode
              value={JSON.stringify(currentCode)}
              type="svg"
              size={320}
              bordered={false}
              style={{ padding: 0, borderRadius: 0 }}
            />
            <div style={{ marginTop: 20 }}>
              {currentCode?.areaTypeDesc}_{currentCode?.alias}
            </div>
          </div>
        </Modal>
      ) : null}
    </div>
  )
}
export default (props: any) => {
  return <SpaceVenueQRCodeList {...props} />
}
